import { gql } from "@apollo/client";

export const CONNECTOR_CALLS = gql`
  query ConnectorCalls(
    $where: ConnectorCallWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    connectorCalls(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      data {
        id
        connectorKey
        category
        status
        request
        response
        error
        durationMs
        attempt
        replay
        replayOfId
        runId
        stepId
        createdDate
      }
      count
    }
  }
`;

const connectorCalls = { CONNECTOR_CALLS };

export default connectorCalls;
